// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4044":"0fbc86a8","5253":"8fb995ff"}[chunkId] + ".chunk.css";
};